export default __webpack_public_path__ + "static/media/MS-video-posterr.b0e60da6.png";